// GENERATED by tools/single-file.py — the ladders below are loop regions inside one bounced
// file, not hand-written numbers. Re-render with:
//   npx vite-node tools/dump-banks.mts /tmp/rerender/banks.json
//   python3 tools/single-file.py /tmp/rerender/banks.json lamborghini-aventador-4v /tmp/rerender/lamborghini-aventador   (sources: see the docstring)
//   python3 tools/single-file.py encode lamborghini-aventador-4v /tmp/rerender/lamborghini-aventador && python3 tools/apply-ladders.py ...
import type { EngineLoopSample } from '../CarProfile';
import { asSingleFile } from '../single-file';
import { lamborghiniAventador } from '../lamborghini-aventador';

const loop = (id: string, file: string, recordedRpm: number, loopStart: number, loopEnd: number): EngineLoopSample =>
  ({ id, file, recordedRpm, loopStart, loopEnd });

export const lamborghiniAventadorSingle = asSingleFile(lamborghiniAventador, {
  id: 'lamborghini-aventador',
  slug: '770-hp-v12',
  name: '770 HP V12',
  baseGain: 1.484,
  adminOnly: false,  // LIVE 2026-09-02 — see the licence note in ../lamborghini-aventador.ts

  limiter: { id: 'limiter', file: 'limiter_single.flac', recordedRpm: 8500 },
  launch: { id: 'launch', file: 'launch_single.flac', recordedRpm: 5100, gain: 1.159 },
  on: [
  loop('on_900', 'single', 900, 0.000000, 11.988896),
  loop('on_1375', 'single', 1375, 11.988896, 25.483729),
  loop('on_1950', 'single', 1950, 25.483729, 27.482292),
  loop('on_2300', 'single', 2300, 27.482292, 29.477937),
  loop('on_2725', 'single', 2725, 29.477937, 31.477417),
  loop('on_3050', 'single', 3050, 31.477417, 33.476250),
  loop('on_3500', 'single', 3500, 33.476250, 35.475896),
  loop('on_3850', 'single', 3850, 35.475896, 37.474000),
  loop('on_4200', 'single', 4200, 37.474000, 39.473458),
  loop('on_5085', 'single', 5085, 39.473458, 41.472854),
  loop('on_5400', 'single', 5400, 41.472854, 43.471438),
  loop('on_5784', 'single', 5784, 43.471438, 45.471292),
  loop('on_6154', 'single', 6154, 45.471292, 47.470896),
  loop('on_6600', 'single', 6600, 47.470896, 49.469542),
  loop('on_7033', 'single', 7033, 49.469542, 51.468521),
  loop('on_7480', 'single', 7480, 51.468521, 53.467458),
  loop('on_8010', 'single', 8010, 53.467458, 55.467271),
  loop('on_8342', 'single', 8342, 55.467271, 57.467271),
  loop('on_8950', 'single', 8950, 57.467271, 59.466875),
  ],
  mid: [
  loop('mid_900', 'single', 900, 59.466875, 71.455771),
  loop('mid_1375', 'single', 1375, 71.455771, 84.955771),
  loop('mid_1950', 'single', 1950, 84.955771, 86.953646),
  loop('mid_2300', 'single', 2300, 86.953646, 88.949292),
  loop('mid_2725', 'single', 2725, 88.949292, 90.948688),
  loop('mid_3050', 'single', 3050, 90.948688, 92.948688),
  loop('mid_3500', 'single', 3500, 92.948688, 94.945833),
  loop('mid_3850', 'single', 3850, 94.945833, 96.945667),
  loop('mid_4200', 'single', 4200, 96.945667, 98.945167),
  loop('mid_5085', 'single', 5085, 98.945167, 100.944521),
  loop('mid_5400', 'single', 5400, 100.944521, 102.944521),
  loop('mid_5784', 'single', 5784, 102.944521, 104.943000),
  loop('mid_6154', 'single', 6154, 104.943000, 106.942937),
  loop('mid_6600', 'single', 6600, 106.942937, 108.942625),
  loop('mid_7033', 'single', 7033, 108.942625, 110.941854),
  loop('mid_7480', 'single', 7480, 110.941854, 112.941771),
  loop('mid_8010', 'single', 8010, 112.941771, 114.941646),
  loop('mid_8342', 'single', 8342, 114.941646, 116.940542),
  loop('mid_8950', 'single', 8950, 116.940542, 118.940187),
  ],
  off: [
  loop('off_900', 'single', 900, 118.940187, 130.929083),
  loop('off_1375', 'single', 1375, 130.929083, 144.429083),
  loop('off_1950', 'single', 1950, 144.429083, 146.429083),
  loop('off_2300', 'single', 2300, 146.429083, 148.424729),
  loop('off_2725', 'single', 2725, 148.424729, 150.424187),
  loop('off_3050', 'single', 3050, 150.424187, 152.424187),
  loop('off_3500', 'single', 3500, 152.424187, 154.421333),
  loop('off_3850', 'single', 3850, 154.421333, 156.420521),
  loop('off_4200', 'single', 4200, 156.420521, 158.418667),
  loop('off_5085', 'single', 5085, 158.418667, 160.417438),
  loop('off_5400', 'single', 5400, 160.417438, 162.416521),
  loop('off_5784', 'single', 5784, 162.416521, 164.415750),
  loop('off_6154', 'single', 6154, 164.415750, 166.415271),
  loop('off_6600', 'single', 6600, 166.415271, 168.415125),
  loop('off_7033', 'single', 7033, 168.415125, 170.414083),
  loop('off_7480', 'single', 7480, 170.414083, 172.413479),
  loop('off_8010', 'single', 8010, 172.413479, 174.412396),
  loop('off_8342', 'single', 8342, 174.412396, 176.411583),
  loop('off_8950', 'single', 8950, 176.411583, 178.410458),
  ],
});
